/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1PersonIdDocumentsMutationRequest,
  PutApiV1PersonIdDocumentsMutationResponse,
  PutApiV1PersonIdDocumentsPathParams,
  PutApiV1PersonIdDocuments400,
  PutApiV1PersonIdDocuments401,
  PutApiV1PersonIdDocuments404,
  PutApiV1PersonIdDocuments409,
  PutApiV1PersonIdDocuments500,
} from "../../types/personRegisterController/PutApiV1PersonIdDocuments.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1PersonIdDocuments } from "../../clients/personRegisterController/putApiV1PersonIdDocuments.ts";

export const putApiV1PersonIdDocumentsMutationKey = () =>
  [{ url: "/api/v1/person/:id/documents" }] as const;

export type PutApiV1PersonIdDocumentsMutationKey = ReturnType<
  typeof putApiV1PersonIdDocumentsMutationKey
>;

export function putApiV1PersonIdDocumentsMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PutApiV1PersonIdDocumentsMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = putApiV1PersonIdDocumentsMutationKey();
  return mutationOptions<
    PutApiV1PersonIdDocumentsMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdDocuments400
      | PutApiV1PersonIdDocuments401
      | PutApiV1PersonIdDocuments404
      | PutApiV1PersonIdDocuments409
      | PutApiV1PersonIdDocuments500
    >,
    {
      id: PutApiV1PersonIdDocumentsPathParams["id"];
      data?: PutApiV1PersonIdDocumentsMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return putApiV1PersonIdDocuments(id, data, config);
    },
  });
}

/**
 * @description Atualiza parcialmente os documentos de uma pessoa. Valida unicidade de CPF. **(Requer Authorization para autenticação)**
 * @summary Atualizar dados de documentos (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/documents}
 */
export function usePutApiV1PersonIdDocuments<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1PersonIdDocumentsMutationResponse,
      ResponseErrorConfig<
        | PutApiV1PersonIdDocuments400
        | PutApiV1PersonIdDocuments401
        | PutApiV1PersonIdDocuments404
        | PutApiV1PersonIdDocuments409
        | PutApiV1PersonIdDocuments500
      >,
      {
        id: PutApiV1PersonIdDocumentsPathParams["id"];
        data?: PutApiV1PersonIdDocumentsMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiV1PersonIdDocumentsMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiV1PersonIdDocumentsMutationKey();

  const baseOptions = putApiV1PersonIdDocumentsMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1PersonIdDocumentsMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdDocuments400
      | PutApiV1PersonIdDocuments401
      | PutApiV1PersonIdDocuments404
      | PutApiV1PersonIdDocuments409
      | PutApiV1PersonIdDocuments500
    >,
    {
      id: PutApiV1PersonIdDocumentsPathParams["id"];
      data?: PutApiV1PersonIdDocumentsMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PutApiV1PersonIdDocumentsMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdDocuments400
      | PutApiV1PersonIdDocuments401
      | PutApiV1PersonIdDocuments404
      | PutApiV1PersonIdDocuments409
      | PutApiV1PersonIdDocuments500
    >,
    {
      id: PutApiV1PersonIdDocumentsPathParams["id"];
      data?: PutApiV1PersonIdDocumentsMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1PersonIdDocumentsMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdDocuments400
      | PutApiV1PersonIdDocuments401
      | PutApiV1PersonIdDocuments404
      | PutApiV1PersonIdDocuments409
      | PutApiV1PersonIdDocuments500
    >,
    {
      id: PutApiV1PersonIdDocumentsPathParams["id"];
      data?: PutApiV1PersonIdDocumentsMutationRequest;
    },
    TContext
  >;
}
